jQuery(document).ready(function ($) {
  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  function updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  jQuery('.isAccordion').on('click', function () {
    if (jQuery(window).width() < 991) {
      if (!jQuery(this).hasClass('opened')) {
        jQuery(this).parents('footer').find('.opened').removeClass('opened')
        jQuery(this).parents('footer').find('.footer-column__body').slideUp()
        jQuery(this).addClass('opened')
        jQuery(this).parents('.footer-column').find('.footer-column__body').slideDown()
      } else {
        jQuery(this).parents('footer').find('.opened').removeClass('opened')
        jQuery(this).parents('footer').find('.footer-column__body').slideUp()
      }
    }
  })
  jQuery('.accordionTitle').on('click', function () {
    if (!jQuery(this).hasClass('opened')) {
      jQuery(this).parents('.accordionContainer').find('.opened').removeClass('opened')
      jQuery(this).parents('.accordionContainer').find('.accordionBody').slideUp()
      jQuery(this).addClass('opened')
      jQuery(this).parents('.accordionWrapper').find('.accordionBody').slideDown()
    } else {
      jQuery(this).parents('.accordionContainer').find('.opened').removeClass('opened')
      jQuery(this).parents('.accordionContainer').find('.accordionBody').slideUp()
    }
  })
  jQuery(document).on('click', '.openPopup', function () {
    jQuery('html').addClass('popupOpened')
  })
  jQuery(document).on('click', '.closeBtn', function () {
    jQuery('html').removeClass('popupOpened')
  })
  jQuery(document).on('click', '#cart-icon-bubble', function (e) {
    if (window.location.pathname == '/cart') return

    e.preventDefault()
    jQuery('html, body').scrollTop(0)
    const cartNotification = document.querySelector('cart-notification');
    cartNotification.open();
  })
  jQuery(document).on('change', '.cart-notification__action .quantity__input', function () {
    const getSectionsToRender = [
      {
        id: 'cart-notification-count',
        section: 'cart-notification-count',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-notification-count',
        selector: '.shopify-section'
      },
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: '#cart-notification-form'
      },
      {
        id: 'cart-notification-subtotal',
        section: 'cart-notification-subtotal',
        selector: '.shopify-section'
      }
    ]
    const line = jQuery(this).data('index')
    const quantity = jQuery(this).val()
    const body = JSON.stringify({
      line,
      quantity,
      sections: ["cart-notification-count", "cart-notification-product", "cart-notification-subtotal"],
      sections_url: '/'
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        getSectionsToRender.forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
      }).catch((e) => {
        document.getElementById('cart-notification__error').textContent = window.cartStrings.error;
      });

      // Extend - Dispatch event
      window.setTimeout(() => {
        window.dispatchEvent(new Event('refreshAjaxCart'))
      }, 800);
      // Extend - End code

  })

  jQuery(document).on('click', '.mobile-facets__close, .mobile-facets__wrapper .button--primary', function() {
    jQuery('html').removeClass('showFilter showSort')
  })

  jQuery(document).on('click', '.filterLink', function() {
    jQuery('html').addClass(jQuery(this).data('class'))
    jQuery('.mobile-facets__open').trigger('click')
  })

  jQuery(document).on('click', '.wishlistButton', function() {
    jQuery(document).find('.ssw-fave-btn-content').trigger('click')
  })

  jQuery(document).on('click', '.dropaHintButton', function(e) {
    e.preventDefault()
    jQuery(document).find('.hvr-fade').trigger('click')
  })
})

const config = {
  attributes: true,
  childList: true,
  subtree: true
}
const wishListMutation = (mutationList, observer) => {
  for (const mutation of mutationList) {
    const product__info = mutation.target.closest('.product__info-container')
    let addToWishlist = false
    if(mutation.addedNodes.length > 1) {
      product__info.classList.add('hasWishlist')
      if(mutation.target.querySelector('.ssw-wishlist-btn')) {
        mutation.target.closest('.shopify-block').style.display = "none"
        if(mutation.target.querySelector('.ssw-wishlist-btn').ariaLabel == "Remove from Wishlist" || mutation.target.ariaLabel == "Remove from Wishlist") {
          addToWishlist = true
        }

        if(addToWishlist) {
          setTimeout(() => {
            product__info.classList.add('addToWishlist')
          }, 10)
        }
      }
    }

    if (mutation.type === 'attributes') {
      if(mutation.target.ariaLabel == "Remove from Wishlist") {
        product__info.classList.add('addToWishlist')
      } else {
        product__info.classList.remove('addToWishlist')
      }
    }
  }
}
const dropHintMutation = (list, obs) => {
  list.map(item => {
    if(item.target.querySelector('#dropahint')) {
      const dropaHintButton = item.target.closest('.product__info-container').querySelector('.dropaHintButton')
      dropaHintButton.style.display = "block"
    }
  })
}
const wishListObserver = new MutationObserver(wishListMutation);
const dropHintObserver = new MutationObserver(dropHintMutation);

const widgetFaveHtmls = document.querySelectorAll('#widget-fave-html')
Array.from(widgetFaveHtmls).forEach(widgetFaveHtml => {
  wishListObserver.observe(widgetFaveHtml, config)
})
const dropaHintHtmls = document.querySelectorAll('.product-form')
Array.from(dropaHintHtmls).forEach(dropaHintHtml => {
  dropHintObserver.observe(dropaHintHtml, config)
})

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}